import { Injectable } from '@angular/core';
import { Observable, Subject, map } from 'rxjs';

import { ApThemeService } from '@ap/theme';
import { MijnOverzichtResource } from '@ap/interface-apix-mijn-overzicht';

import { BrandNumbers, CustomerTypes } from './mijn-feedback.model';

@Injectable({ providedIn: 'root' })
export class MijnFeedbackService {
    private readonly feedbackPostedSubject = new Subject<boolean>();

    constructor(
        private readonly mijnOverzichtResource: MijnOverzichtResource,
        private readonly apThemeService: ApThemeService
    ) {}

    public get merkNummer(): BrandNumbers {
        switch (this.apThemeService.getTheme()) {
            case 'sns':
                return '28';
            case 'asn':
                return '270';
            case 'blg':
                return '40';
            case 'reb':
                return '230';
            default:
                return '28';
        }
    }

    public getCustomerType(): Observable<CustomerTypes> {
        return this.mijnOverzichtResource.getContractDetails().pipe(map((value) => (value.is_zakelijk ? 'ZAKELIJK' : 'PARTICULIER')));
    }

    public setFeedbackPosted(): void {
        this.feedbackPostedSubject.next(true);
    }

    public getIsFeedbackPosted(): Observable<boolean> {
        return this.feedbackPostedSubject;
    }
}
